import UITextField from "@/components/ui-controls/textfield";
import Box from "@mui/material/Box";

export default function EditableCell({
  type = "text",
  value = "",
  field = "status",
  postFix = "",
  // onSave,
  onCancel,
  onChange,
  onKeyDown,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "5px",
        maxWidth: "300px",
      }}
    >
      <UITextField
        type={type}
        name={field}
        value={value || ""}
        autoFocus={true}
        postfix={postFix}
        // multiline={type == "text-area" && 4}
        // title={title}
        // placeholder={placeholder}
        onChange={onChange}
        onBlur={onKeyDown}
        onKeyDown={onKeyDown}
        // tooltip={tooltip}
        // prefix={prefix}
        // error={
        //   (FormikForm.touched[field] && FormikForm.errors[field]) || false
        // }
      />
    </Box>
  );
}
